// CMP client id object used for Preclub queries -> Mapped with cmp-clients table in dynamo

let cmpClientIdObject = {
  "8c001fde-3728-48dc-9950-b8480ca9fbee": "33", // Baja Fresh
  "1857ba2f-010f-4f49-bcd1-f9fd09db2799": "22", // Primanti Bro's
  "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f": "13", // Bad Daddy's
  "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534": "30", // Lou Malnatis
  "f0d3b19b-a564-43e9-85dd-bd95f8b13f97": "31", // Data Delivers Cafe / Data Delivers
  "52b86a20-91ae-457b-a6c7-f7708431b645": "1", // HouliHan's
  "19357b26-ddae-4b3a-9e95-b5879f1e9572": "32", // Uncle Julios
  "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9": "9", // SeaFood Grill
  "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406": "1", // HouliHan's NE
  "74d71e90-46e0-45b8-9b6e-a96883e85d54": "4", // Morton's
  "7abec586-17b8-4174-993d-e3d86648ed60": "1", // HouliHan's CEN
  "2b7ed789-e2d0-45c0-a45f-49e27d736a7b": "29", // J.Gilbert's
  "c566b59a-7y94-4ag0-96cf-88av8084d1s3": "31", // Cogensia Cafe
  "687c8c2a-0986-4147-bf38-0d5bac9f7530": "36", // Eegee's
  "b44cc84d-73b5-4457-bb48-68e9626d08e1": "39", // Viva Chicken
  "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c": "38", // Brusters
};

export default cmpClientIdObject;


// WEBPACK FOOTER //
// ./src/client-id.js